import { render } from "./ClockingLoader.vue?vue&type=template&id=6b843bfb&scoped=true"
import script from "./ClockingLoader.vue?vue&type=script&lang=js"
export * from "./ClockingLoader.vue?vue&type=script&lang=js"

import "./ClockingLoader.vue?vue&type=style&index=0&id=6b843bfb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b843bfb"]])

export default __exports__